// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"963993e8","148":"5765fbcc","345":"1efae987","388":"40734586","727":"abba28e4","780":"92f7694c","804":"631e156f","879":"0c334bfa","884":"4027e00a"}[chunkId] + ".chunk.js";
};